<template>
  <v-table class="table_variant_surcharge">
    <thead>
      <tr>
        <th
          class="text-left"
          colspan="3">
          {{
            $t(
              "components.Calculations.Variants.ViewParts.SurchargeCashSalePriceTab.ProfitSurcharge"
            )
          }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="wide_col">
          <CalcInputNumber
            :id="nodeId"
            field="profit_surcharge_rate_material_percentage_part"
            :rules="[percents]" />
        </td>
        <td class="input_col">
          <CalcOutput
            :id="nodeId"
            field="profit_on_material_part"
            hide-label />
        </td>
        <td class="e_per_piece_col">
          {{ $t("units.e_per_piece") }}
        </td>
      </tr>

      <tr>
        <td class="wide_col">
          <CalcInputNumber
            :id="nodeId"
            field="profit_surcharge_rate_manufacturing_percentage_part"
            :rules="[percents]" />
        </td>
        <td class="input_col">
          <CalcOutput
            :id="nodeId"
            field="profit_on_manufacturing_part"
            hide-label />
        </td>
        <td class="e_per_piece_col">
          {{ $t("units.e_per_piece") }}
        </td>
      </tr>

      <tr>
        <td class="wide_col text-right">
          {{
            $t(
              "components.Calculations.Variants.ViewParts.SurchargeCashSalePriceTab.ProfitSurcharge"
            )
          }}
        </td>
        <td class="input_col">
          <CalcOutput
            :id="nodeId"
            field="profit_part"
            hide-label />
        </td>
        <td class="e_per_piece_col">
          {{ $t("units.e_per_piece") }}
        </td>
      </tr>
    </tbody>
  </v-table>
</template>

<script setup>
import CalcOutput from "../../../../../components/Elements/CalcOutput.vue";
import CalcInputNumber from "@/components/Elements/CalcInputNumber.vue";

import { useTranslation } from "i18next-vue";

import { useCommonRules } from "@/validations/common";
const { t } = useTranslation();
const { percents } = useCommonRules(t);

defineProps({
  variant: {
    type: Object,
    required: true
  },
  nodeId: {
    type: String,
    required: true
  }
});
</script>
